module.exports = __webpack_public_path__ + "assets/bcfd44334ae8b94e4bdcbbf23c824682.json";